export const API_URL = "https://api.betared.sk/api/v1";
export const IMG_URL = "https://img.betared.sk/"

export const getURL = () => {
    return {
        API_URL,
        IMG_URL,
    }
};
